import { z } from 'zod';

export const MAX_PAGE_SIZE = 50;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_NUMBER = 1;

export const CurrencyEnum = {
  NGN: 'NGN',
  USD: 'USD',
  GBP: 'GBP',
  EUR: 'EUR',
} as const;
export type CurrencyEnum = (typeof CurrencyEnum)[keyof typeof CurrencyEnum];
/**
 * Common pagination parameters for query strings.
 */
export const PaginationParamsSchema = z.object({
  pageNumber: z.coerce.number().int().min(1).default(DEFAULT_PAGE_NUMBER),
  pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});

export const MoneySchema = z.object({
  amountMinor: z.string().regex(/^-?\d+$/, 'amountMinor must be a signed integer string'),
  currency: z.enum(CurrencyEnum),
});

export const DeltaDirection = {
  UP: 'UP',
  DOWN: 'DOWN',
  FLAT: 'FLAT',
} as const;
export type DeltaDirection = (typeof DeltaDirection)[keyof typeof DeltaDirection];
export const DeltaDirectionSchema = z.enum(DeltaDirection);

/**
 * Common pagination metadata returned alongside list responses.
 */
export const PaginationResponseSchema = z.object({
  totalCount: z.number().int().nonnegative(),
  pageNumber: z.number().int().min(1),
  pageSize: z.number().int().min(1),
  totalPages: z.number().int().nonnegative(),
  hasPreviousPage: z.boolean(),
  hasNextPage: z.boolean(),
});

/**
 * Standard API response wrapper for all LivDot endpoints.
 * @template T The type of the data payload.
 */
export const ApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    success: z.boolean(),
    data: dataSchema.optional(),
    error: z
      .object({
        type: z.url(),
        title: z.string(),
        status: z.number(),
        detail: z.string(),
        instance: z.string().optional(),
      })
      .optional(),
    meta: PaginationResponseSchema.optional(),
  });

export type PaginationParams = z.infer<typeof PaginationParamsSchema>;
export type PaginationResponse = z.infer<typeof PaginationResponseSchema>;
export type MoneyDto = z.infer<typeof MoneySchema>;
